import { render } from "./DownloadLink.vue?vue&type=template&id=1de6c5ac"
import script from "./DownloadLink.vue?vue&type=script&lang=js"
export * from "./DownloadLink.vue?vue&type=script&lang=js"

import "./DownloadLink.vue?vue&type=style&index=0&id=1de6c5ac&lang=scss"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__